
import Vue from "vue";
import { Purchase } from "@/models/base";
import AppInfoInput from "@/components/common/InfoInput.vue";
import { TranslateResult } from "vue-i18n";
import AppAwsFiles from "@/components/aws-files-modules/AwsFilesInfo.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => Purchase,
			required: true
		},
	},
	computed: {
		purchaseType():TranslateResult{
			if (this.value.IsCreditNote){
				return this.$ct("type-creditnote");
			}
			return this.$ct("type-invoice");
		},
		ogm():string{
			if (!this.value.Ogm) return "";
			let ogm = this.value.Ogm;
			let part1 = ogm.substring(0, 3);
			let part2 = ogm.substring(3, 7);
			let part3 = ogm.substring(7, 12);
			return `+++ ${part1} / ${part2} / ${part3} +++`;
		}
	},
	components: {
		AppInfoInput,
		AppAwsFiles
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
